<template>
    <div class="inner-wrapper">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{successMessage}}
        </div>

        <!--<div class="page-title">
            <h1 class="float-left">Draft Sales Orders</h1>
            <div class="title-right float-right">

            </div>
        </div>-->
        <div class="new-rfq">
            <fieldset class="customer-search">
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="row g-2">
                            <div class="col-lg-auto">

                                <div class="filter-sec">
                                    <button type="button" class="btn filter-btn btn-primary" @click="showFilters=!showFilters">
                                        <i class="ri-filter-line align-bottom me-1"></i> Filters
                                    </button>
                                </div>
                            </div><!--end col-->
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="input-group">

                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i class="fa fa-search" aria-hidden="true"></i></button>
                                        </div>
                                        <input v-model="filterData.search_filter" type="text" class="form-control" placeholder="Quick Search">
                                    </div>
                                </form>

                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">
                                        <router-link :to="{ name: 'selectCustomer'}" class="btn btn-primary"><i class="ri-add-circle-line align-bottom me-1"></i> Create Order</router-link>
                                        <div class="quotes-text"><b>{{totalOrders}} Orders</b></div>
                                    </div>
                                </div>
                            </div><!--end col-->
                        </div><!--end row-->
                        <div class="qfilter mt-2" style="display: none;">
                            <div class="d-md-flex d-block align-items-center">
                                <div class="mt-1 me-2" style="flex: 1;">
                                    <select class="form-select">
                                        <option>Status</option>
                                        <option>One</option>
                                        <option>Two</option>
                                        <option>Three</option>
                                        <option>Four</option>
                                    </select>
                                </div>
                                <div class="mt-1 me-2" style="flex: 1;">
                                    <select class="form-select">
                                        <option>Sales REP</option>
                                        <option>One</option>
                                        <option>Two</option>
                                        <option>Three</option>
                                        <option>Four</option>
                                    </select>
                                </div>
                                <div class="mt-1 me-2" style="flex: 1;">
                                    <select class="form-select">
                                        <option>Added By</option>
                                        <option>One</option>
                                        <option>Two</option>
                                        <option>Three</option>
                                        <option>Four</option>
                                    </select>
                                </div>
                                <div class="mt-1 me-2" style="flex: 1;">
                                    <select class="form-select">
                                        <option>Time Frame</option>
                                        <option>One</option>
                                        <option>Two</option>
                                        <option>Three</option>
                                        <option>Four</option>
                                    </select>
                                </div>
                                <div class="mt-1">
                                    <div class="d-grid gap-2">
                                        <button class="btn btn-primary"><i class="ri-search-line search-icon"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="filter-row" v-if="showFilters">
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.status_search">
                                    <option :value="null">Status</option>
                                    <option v-for="(status, index) in filters.statuses" :value="status.id">
                                        {{ status.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <v-select label="text" :filterable="false"
                                        v-model="customer"
                                        :options="customers"
                                        placeholder="Customer"
                                        @input="onCustomerSelect"
                                        @search="onCustomerSearch"
                                        @selected="onCustomerSelect"
                                        @deselected="onCustomerDeSelect">
                                    <template slot="no-options">
                                        type to search customers..
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.html">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.text">
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.sale_user_id">
                                    <option :value="null">Sales REP</option>
                                    <option v-for="(sale_user, index) in filters.sale_users" :value="sale_user.id">
                                        {{ sale_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_added_user_id">
                                    <option :value="null">Added By</option>
                                    <option v-for="(admin_user, index) in filters.admin_users" :value="admin_user.id">
                                        {{ admin_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_by_date">
                                    <option :value="null">Time Frame</option>
                                    <option value="0">All Time</option>
                                    <option value="1">Today</option>
                                    <option value="2">This week</option>
                                    <option value="3">This Month</option>
                                    <option value="4"> This Year</option>
                                    <option value="5">Custom Range</option>
                                </select>
                            </div>
                            <div class="search-btnsec"><button class="btn btn-success" type="button" @click.prevent="search"><i class="fa fa-search" aria-hidden="true"></i></button></div>
                        </div>
                    </div><!--end card-body-->
                </div><!--end card-->


                <div class="row" v-if="showFilters">
                    <div class="col-md-3">
                        <date-picker v-if="filterData.search_by_date == 5" format="MM/DD/YYYY"
                                     v-model="filterData.date_range" range></date-picker>
                    </div>
                </div>
            </fieldset>

            <OrderList :filterData="filterData"
                       :bus="bus" ref="orderList"
                       :is_draft="1"
                       @returnTotalNumOrders="setTotalOrders" @deleteItem="removeItem" @onDeleteMultiple="deleteMultiple"></OrderList>



        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";
import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import OrderList from "../../components/OrderList";

export default {
    name: "DraftOrders",
    components: {
        OrderList, DatePicker
    },
    created() {
        this.getOrderFilters();
    },
    data(){
        return {
            bus: new Vue(),
            isListView: false,
            totalOrders: 0,
            showFilters: false,
            filters: {
                statuses: [],
                sale_users: [],
                admin_users: [],
            },
            filterData: {
                search_filter: null,
                sale_user_id: null,
                search_customer_id: null,
                search_added_user_id: null,
                search_by_date: null,
                status_search: null,
                date_range: null
            },
            customers: [],
            customer: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading',
            'setLoading'
        ]),

        removeItem(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.delete(window.route('orders.destroy', {id: event.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.bus.$emit('resetOrderDeleteSelection');
                        self.bus.$emit('getOrders');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteMultiple(selectedOrdersForDelete){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('deleteSelectedOrders'), {ids: selectedOrdersForDelete}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.bus.$emit('getOrders');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        search() {
            this.bus.$emit('getOrders')
        },
        setTotalOrders(event){
            this.totalOrders = event;
        },
        getOrderFilters() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.getFilters'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors && data.errors.length) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.filters = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        onCustomerSelect(event) {
            if (event) {
                this.filterData.search_customer_id = event.id;
            } else {
                this.filterData.search_customer_id = null;
            }
        },
        onCustomerDeSelect(event) {
            this.filterData.search_customer_id = null;
        },
        onCustomerSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchCustomer'), {searchTerm: search, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),

    },
    watch: {
        checkAllOrdersForDelete: {
            handler: function (value) {
                this.bus.$emit('checkOrdersForDelete', value);
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
